import { useTerminalConfig } from "../../Path/NewTerminalConfigs";
import { FaEdit, FaTimes } from "react-icons/fa";
import AddService from "./AddService";
import { useState } from "react";
import { getStatusColor } from "../../Path/AppDashboard";

const ServiceEditRequest = ({ onClose }) => {
    const { terminalConfig, setTerminalConfig } = useTerminalConfig();
    const [editService, setEditService] = useState();
    return <div className="flex flex-wrap gap-2">
        {terminalConfig.selectedServices.map((services) => <div className="relative bg-white rounded-lg shadow-md text-black px-3 py-2 m-1 w-[250px] h-fit flex items-center justify-between transition-all hover:shadow-lg">
            <h6 className="text-sm font-semibold truncate max-w-[110px]">{services.title}</h6>
            <div className="flex items-center space-x-2">
                <div className={`h-[10px] w-[10px] rounded-[50%] ${getStatusColor(services.statusId || 1)} self-center`}></div>
                <FaEdit
                    className="text-blue-600 hover:text-blue-800 cursor-pointer"
                    onClick={() => setEditService(services)}
                />
                <FaTimes
                    className="text-red-500 hover:text-red-700 cursor-pointer"
                    onClick={() => setTerminalConfig((prev) => ({ ...prev, selectedServices: prev?.selectedServices.filter((ser) => ser.id !== services.id) }))}
                />
            </div>
        </div>)}
        {editService?.id && <AddService isEdit={true} serviceData={editService} close={() => {
            setEditService()
            onClose(true)
        }} />}
    </div>
};

export default ServiceEditRequest;
